import React from 'react';
import { bool, string } from 'prop-types';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LanguageFlag from '@components/LanguageFlag';
import { selectLanguage } from '@redux/core/reducers';
import './style.less';

function LanguageIcon({ language, showText }) {
  const languageDetails = useSelector(selectLanguage(language));
  const { t } = useTranslation();

  if (!language || !languageDetails) return null;
  const { name, icon } = languageDetails;

  if (showText) {
    return (
      <span className="language-icon-label">
        <LanguageFlag className="language-icon" icon={icon} />
        {t(name)}
      </span>
    );
  }

  return (
    <Tooltip placement="bottom" title={t(name)}>
      <LanguageFlag className="language-icon" icon={icon} />
    </Tooltip>
  );
}

LanguageIcon.propTypes = {
  language: string,
  showText: bool,
};

LanguageIcon.defaultProps = {
  language: 'en',
  showText: false,
};

export default LanguageIcon;
